import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import StockReturnForm from '../../components/transaction/StockReturnForm';
import StockReturnTable from '../../components/transaction/StockReturnTable';

const StockReturnPage = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  // Replace with actual logged-in user
  const currentUser = 'current_user';
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          component={Link}
          to="/activity-log"
          variant="contained"
          color="primary"
        >
          View Activity Log
        </Button>
      </Box>
      <Box sx={{ minHeight: '100vh', background: '#f6f6f6', py: 4 }}>
        <Box sx={{ maxWidth: '1800px', mx: 'auto', display: 'flex', gap: 3, alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1.5, minWidth: 0 }}>
            <StockReturnTable key={refreshKey} currentUser={currentUser} onDelete={() => setRefreshKey(k => k + 1)} />
          </Box>
          <Box sx={{ flex: 0.6, minWidth: 320 }}>
            <StockReturnForm onSuccess={() => setRefreshKey(k => k + 1)} />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default StockReturnPage; 